<template>
  <div id="my-app">
    <div
      class="tgc-mosaicv2-slim-m tgs-mosaicv2-rootwidget"
    >
      <div :class="getProductId()">
        <PostCode
          @handleUpdateBySuburb="handleUpdateBySuburb"
          :isPrefAvailable="isPrefAvailable"
          :showPostcode="showPostcode"
          :name="localName"/>
        <ArticleList :results="resultsInOrder" :name="localName" v-if="hasEnoughArticles"/>
        <div class="mylocal-message" v-if="isLoading">Loading..</div>
      </div>
    </div>
    <div class="mylocal-readnext__wrapper" v-if="mastheadTitle">
        <a :href="mastheadLink" class="mylocal-readnext__link">
          <div class="mylocal-readnext__text">Read more at <strong>{{mastheadTitle}}</strong></div>
          <div class="mylocal-readnext__icon">
            <svg width="15" height="24" viewBox="0 0 15 24" xmlns="http://www.w3.org/2000/svg"><title>nav_small_right</title><path d="M9.06 12.5L1 21.617 3.432 24l10.494-11.5L3.432 1 1 3.383 9.06 12.5z" fill="#222" fill-rule="evenodd"></path></svg>
          </div>
        </a>
    </div>
    <div class="mylocal-message" v-if="showNotFoundMsg">Add your suburb to see the latest news from your area.</div>
    <div class="mylocal-message" v-if="noArticles">We don't currently provide coverage for this region. Please check back again soon as our local news coverage is expanding</div>
  </div>
</template>

<script>
import axios from 'axios';
import Cookies from 'js-cookie';
import { orderBy, sortedUniqBy } from 'lodash';

import { getArticlesByMasthead, getArticlesBySuburb, PRODUCT_MAP } from './config/api.config';
import { getPreferences, updateMyPreference } from './logic/preferences';
import { filterArticles, getNearbySuburbs, getSuburbInfoByName, matchedMastheadPostcode } from './logic/location';

import masthead from './assets/postcode/masthead.json';

import PostCode from './components/PostCode.vue';
import ArticleList from './components/ArticleList.vue';

export default {
  name: 'app',
  components: {
    PostCode,
    ArticleList
  },
  data: () => {
     return {
       isAuthenticated: Cookies.get('rampart_token') ? true : false,
       showPostcode: window.location.pathname.indexOf('/local/') > -1 ? false : true,
       showNotFoundMsg: false,
       user: {},
       isLoading: false,
       results: [],
       expandSurround: 0,
       localName: '',
       localPostCode: '',
       isPrefAvailable: true,
       mastheadTitle: '',
       mastheadLink: '',
       bestOfText: '', 
       noArticles: false     
     }
  },
  computed: {
    hasEnoughArticles() {
      return this.resultsInOrder.length >= 3;
    },
    resultsInOrder() {
      const getOrder = orderBy(this.results, ['date.live'], ['desc']);
      const getUniq = sortedUniqBy(getOrder, (item) => { return item.headline.default }).splice(0, 4);

      return getUniq;
    }
  },
  methods: {
    getProductId() {
      const findProduct = masthead.filter((item) => item.productName === this.globalConfig.productName);

      const className = findProduct.length > 0 ? findProduct[0].id : '';
      return `u-widthmaxed mylocal__brand-${className}`;
    },
    handleUpdateBySuburb(selectedLocal) {
      
      this.isPrefAvailable = true;
      
      if(this.isAuthenticated) {
        updateMyPreference(
          selectedLocal,
          this.globalConfig.environment
          ).then(() => {
          // Successful! Quietly done!
        });
      }
      this.fetchMasthead(selectedLocal);
    },
    handleUpdateByMasthead(selectedLocal, updateTitle = true) {
      const maxArticles = 4;

      this.fetchApi(selectedLocal, true)
        .then((res) => {
          const results = res.data.data.results;

          if (updateTitle) {
            this.localName = selectedLocal.localName;
          }

          if (results.length > 0) {
            this.results = [];
          }

          this.results = [...this.results, ...results.slice(0, maxArticles)];
          this.isLoading = false;
        });
    },
    fetchApi(localParams, isMasthead = false) {
      this.isLoading = true;

      const apiUrl = isMasthead ?
        getArticlesByMasthead(
          localParams.targetDomain,
          localParams.categoryId,
          localParams.displaySlug,
          localParams.productName,
          this.globalConfig.environment
        ) :
        getArticlesBySuburb(
          localParams.targetDomain,
          localParams.localName,
          localParams.productName,
          this.globalConfig.environment,
          localParams.state
        );

      return axios.get(apiUrl);
    },
    showMastheadBtn(postcode) {
      const matchedMasthead = matchedMastheadPostcode(postcode, this.globalConfig.productName);

      if (matchedMasthead.length > 0) {
        this.mastheadTitle = matchedMasthead[0].localName;
        this.mastheadLink = matchedMasthead[0].link;
      }
    },
    fetchAndExpand(selectedLocal, nearBySuburbs) {
      const maxArticles = 4;
      this.noArticles = false;
      this.showNotFoundMsg = false;
      if (this.expandSurround > nearBySuburbs.length) {
        return;
      }

      const suburb = nearBySuburbs[this.expandSurround];
      const localParam = this.getLocalParams(suburb);

      this.fetchApi(localParam, false)
        .then((res) => {
          const results = res ? (res.data ? res.data.data.results : []) : [];

          const newArticles = results ? filterArticles(this.results, results) : [];

          this.results = [...this.results, ...newArticles];
          this.isLoading = false;
          const endedWithNothing = nearBySuburbs.length - 1 === this.expandSurround && !this.hasEnoughArticles;
          
          if (endedWithNothing) {
            this.noArticlesFound();
          }

          if (this.results.length < maxArticles) {
            this.expandSurround++;
            this.fetchAndExpand(selectedLocal, nearBySuburbs);
          }
        })
        .catch(() => {
          if (this.expandSurround < nearBySuburbs.length - 1) {
            this.expandSurround++;
            this.fetchAndExpand(selectedLocal, nearBySuburbs);
          } else {
            this.isLoading = false;
            this.noArticlesFound();
          }
        })
    },
    fetchMasthead(localParam) {

      if(localParam === undefined) {
        this.noArticlesFound();
        return;
      }

      this.results = [];
      this.noArticles = false;
      this.showNotFoundMsg = false;
      this.expandSurround = 0;
      this.localName = localParam.suburbName || localParam.localName;
      this.localPostCode = localParam.postcode;

      const matchedMasthead = matchedMastheadPostcode(localParam.postcode, this.globalConfig.productName);      

      if (matchedMasthead.length > 0) {
        this.isLoading = true;
        const mastHead = matchedMasthead[0];
        this.mastheadTitle = mastHead.localName;
        this.mastheadLink = mastHead.link;
        this.showMastheadBtn(localParam.postcode);
        this.fetchApi(mastHead, true)
          .then((res) => {
            const results = res ? (res.data ? res.data.data.results : []) : [];

            if(results.length > 0) {
              const newArticles = results ? filterArticles(this.results, results) : [];
              this.results = [...this.results, ...newArticles];
              this.isLoading = false;
            } else {
              this.fetchNearest();
            }
          })
          .catch(() => {
            this.fetchNearest();
          })
      } else {
        this.fetchNearest();
      }
    },
    fetchNearest() {
      const productName = this.globalConfig.productName.toLowerCase();
      const state = PRODUCT_MAP[productName].state;
      const favouriteSuburbInfo = getSuburbInfoByName(this.localName, state);
      const nearBy = getNearbySuburbs(favouriteSuburbInfo);
      this.fetchAndExpand(favouriteSuburbInfo, nearBy);
      this.localName = favouriteSuburbInfo.localName;
      this.mastheadTitle = '';
    },
    getLocalParams(suburb) {
      const productName = this.globalConfig.productName.toLowerCase();
      const targetDomain = PRODUCT_MAP[productName].targetDomain;

      return {
        displaySlug: '',
        productName: this.globalConfig.productName,
        targetDomain,
        localName: suburb.name,
        state: suburb.state,
        categoryId: ''
      }
    },
    getBestOf() {
      const param = masthead.filter(product => product.productName === this.globalConfig.productName);

      return param.length > 0 ? {
        productName: param[0].productName,
        displaySlug: param[0].displaySlug,
        targetDomain: param[0].targetDomain,
        localName: `The best of ${param[0].id}`,
        id: param[0].id,
        categoryId: ''
      } : {}
    },
    handleGetTheBestOf(showMsg = false) {
      const defaultParams = this.getBestOf();
      this.showNotFoundMsg = showMsg;

      this.handleUpdateByMasthead(defaultParams, !showMsg);
    },
    noArticlesFound() {
      this.noArticles = this.isPrefAvailable;
      this.showNotFoundMsg = !this.noArticles;
      this.results = [];
      this.isLoading = false;
      this.mastheadTitle = '';
    }
  },
  mounted () {
    this.isLoading = true;
    if(this.isAuthenticated) {
      getPreferences(this.globalConfig.environment, this.globalConfig.productName)
        .then((userPref) => {      
          const favouriteSuburb = JSON.parse(userPref[this.globalConfig.productName]);
          this.fetchMasthead(favouriteSuburb);
          this.localPostCode = favouriteSuburb.postcode;
        })
        .catch(() => {        
          this.isPrefAvailable = false;
          this.noArticlesFound();
        });      
    } else {
      this.isPrefAvailable = false;
      this.isLoading = false;
      this.noArticlesFound();
    }
  }
}
</script>

<style scoped>
#my-app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin-top: 60px;
  margin: auto;
  max-width: 1000px;
}

.mylocal-message {
  text-align: center;
  font-weight: 600;
  font-size: 15px;
}

.mylocal-message a{
  text-decoration: underline;
  color: #2c3e50;
  display: inline-block;
}

.mylocal-readnext__wrapper {
  display: flex;
  justify-content: flex-end;
}

.mylocal-readnext__link {
  display: inline-flex;
  border-radius: 15px;
  background: #ebebeb;
  justify-content: center;
  text-decoration: none;
  color: #000;
  align-items: center;
  padding: 0 0 0 10px;
  margin-bottom: 5px;
}

.mylocal-readnext__icon {
  border-radius: 50%;
  background: #FFF;
  width: 24px;
  height: 24px;
  margin: 5px;
  padding: 3px;
  display: block;
  text-align: center;
}

.mylocal-readnext__icon svg {
  height: 100%;
  margin: auto;
}
</style>
